var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillBuildEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.6 12.4H12.4V6.5L9.5 3.6H3.6V12.4ZM3.6 13.6C3.27 13.6 2.9875 13.4825 2.7525 13.2475C2.5175 13.0125 2.4 12.73 2.4 12.4V3.6C2.4 3.27 2.5175 2.9875 2.7525 2.7525C2.9875 2.5175 3.27 2.4 3.6 2.4H10L13.6 6V12.4C13.6 12.73 13.4825 13.0125 13.2475 13.2475C13.0125 13.4825 12.73 13.6 12.4 13.6H3.6ZM4.8 11.2H11.2V10H4.8V11.2ZM4.8 8.8H11.2V7.6H4.8V8.8ZM4.8 6.4H9.6V5.2H4.8V6.4Z",
    fill: "#155DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillBuildEvidence);
export default __webpack_public_path__ + "static/media/pill_build_evidence.fd071b50e773f147675e36d61c85302e.svg";
export { ForwardRef as ReactComponent };